import { useState } from 'react'
import { useDispatch } from 'react-redux'

import { notify } from 'helpers/notification'
import {
    sendOtp as sendOtpRequest,
    verifyOtp as verifyOtpRequest,
} from 'services/apis/otp'
import { performLogin, removeUserCookies } from 'store/thunks/User'

import { handleError } from '../../helpers/error'
/**
 * This hook is used to perform actions based on
 * the OTP and phone number input by the user.
 *
 * This hook exposes abiltity to change the userModel states
 * Do not alter the userModel state for OTP using any other way
 */

const useLoginOtp = () => {
    // local hooks
    const [otpSending, setOtpSending] = useState(false)
    const [otpVerifying, setOtpVerifying] = useState(false)
    const dispatch = useDispatch()

    /**
     * Takes in the phone number of the user and sends OTP
     * to the mobile phone of the user
     *
     * @param phone_number
     */

    const sendOtp = async phone_number => {
        if (!phone_number) {
            notify.error('Incorrect mobile number')
            return
        }
        try {
            notify.success('OTP Sent')
            removeUserCookies()
            setOtpSending(true)
            await sendOtpRequest({ phone_number })
            setOtpSending(false)
        } catch (error) {
            handleError(error)
            setOtpSending(false)
        }
    }

    /**
     * Takes in the same phone number and the received OTP to
     * return an access token in form of a JWT
     * This JWT is then used as a auth header for all other
     * protected routes
     *
     * @param phone_number
     * @param otp
     */
    const verifyOtp = async (phone_number, otp) => {
        if (!phone_number || !otp) {
            return
        }
        try {
            setOtpVerifying(true)
            const { data } = await verifyOtpRequest({
                phone_number: phone_number,
                otp: otp,
            })
            setOtpVerifying(false)
            dispatch(performLogin(data))
        } catch (error) {
            handleError(error)
            setOtpVerifying(false)
        }
    }

    return { sendOtp, otpSending, verifyOtp, otpVerifying }
}

export default useLoginOtp
